const config = {
    dexfApiKey: 'ba74f79f-83f2-4317-86ad-6cde80b1f630',
    dexfApiUrl: 'https://api.dexf.ikea.com/product/v1/query',
    qaInsightsUrl: 'https://qa.ml.ipex-insights.com/beta/designs/guide/guida',
    insightsurl: 'https://ml.ipex-insights.com/beta/designs/guide/guida',
    insightsDevApiKey: '91qy003gy9ij8q2c',
    insightsApiKey: '410ttrsjjdbrle4t',
    paxDexfApplicationId: 'storageonepax',
    guidaDexfApplicationId: 'guida',
    paxApplicationName: 'storageonepax'
};
export default config;
//# sourceMappingURL=config.js.map